export const NL: Record<string, string> = {
  "Recommended for you": "Aanbevolen voor u",
  "Resource added to favorite": "Resource toegevoegd aan favorieten",
  "Failed to add resource to favorite": "Toevoegen van resource aan favorieten mislukt",
  "Resource removed from favorite": "Resource verwijderd uit favorieten",
  "Failed to remove resource from favorite": "Verwijderen van resource uit favorieten mislukt",
  "Calendar": "Kalender",
  "View Detail": "Details bekijken",
  "Add to favorites": "Toevoegen aan favorieten",
  "Remove from favorites": "Verwijderen uit favorieten",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Beschrijving: VIP-vergaderruimte met een prachtig uitzicht en comfortabele stoelen.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Er zijn geen beschikbare resources op het gekozen tijdstip op uw locatie of in uw favorieten.",
  "You have these options:": "U heeft deze opties:",
  "Change the meeting time.": "Wijzig de vergadertijd.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Gebruik de knop <1>Beschikbare tijd zoeken</1> om een nieuwe tijd te kiezen.",
  "Open the search to find other resources.": "Open de zoekopdracht om andere resources te vinden.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "De resource type <1>'{{resourceType}}'</1> bestaat niet op uw standaardlocatie",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "De resource type <1>'{{resourceType}}'</1> kan worden gevonden op een andere locatie.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Klik hier</1> om de resource type toe te voegen aan uw standaardlocatie-instellingen.",
  
  // ResourceCard
  "New Order": "Nieuwe bestelling",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Bij boeken van een Pooled Resource kan alleen deze resourcetype en slechts één ressource worden gebokt.",
  "You cannot select both a child resource and its virtual resource at the same time.": "U kunt niet beide een kindresource en zijn virtuele resource tegelijk selecteren.",
  // Settings
  "Note:": "Opmerking:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Een assistent-organisator kan dezelfde e-mails van Resource Central ontvangen als de organisator en kan bestellingen namens de organisator afhandelen.",
  "Setting updated successfully": "Instelling succesvol bijgewerkt",
  "Setting updated failed": "Bijwerken van instelling mislukt",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 plaats",
  "Opening hours:": "Openingstijden:",
  "Buffer time {{minutes}} mins between reservations": "Buffertijd {{minutes}} min tussen reserveringen",
  "Initial payment {{value}} pr.minute": "Initiële betaling {{value}} per minuut",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Totaal {{total}} deelnemers",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} van {{total}} interne kunnen aanwezig zijn.",
  "{{external}} external is unknown.": "{{external}} externe zijn onbekend.",
  "Find available time": "Beschikbare tijd zoeken",
  "Attendees": "Deelnemers",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Klik op Meer informatie om onze ondersteuningssite te bezoeken",
  "Further information": "Meer informatie",
  
  // LocationSetting
  "Location changed": "Locatie gewijzigd",
  "Location change failed": "Wijzigen van locatie mislukt",
  "Please select at least one location": "Selecteer ten minste één locatie",
  "Resource types": "Resource types",
  "Location": "Locatie",
  "Where": "Waar",
  
  // ModalShowAttendees
  "Total": "Totaal",
  "Available": "Beschikbaar",
  "Busy": "Bezet",
  "External": "Extern",
  "Internal": "Intern",
  
  // ResourceSearch
  "Search by resource name": "Zoeken op resourcenaam",
  "Category": "Categorie",
  "Filter by Location": "Filteren op locatie",
  "Filter by Category": "Filteren op categorie",
  "Capacity": "Capaciteit",
  "Filter by Capacity": "Filteren op capaciteit",
  "All": "Alle",
  "Filter by availability": "Filteren op beschikbaarheid",
  "Sort By": "Sorteren op",
  "Loading...": "Laden...",
  
  // SelectedResources
  "Meeting Type": "Vergadertype",
  "Meeting Label": "Vergaderlabel",
  
  // Alert (accessibility text)
  "Check icon": "Vinkje pictogram",
  "Close": "Sluiten",
  
  // AppConstants - searchTab
  "Resource": "Resource",
  "Person": "Persoon",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Waar vinden uw vergaderingen meestal plaats?",
  "To improve our recommendations for you we would like you to enter your normal location": "Om onze aanbevelingen voor u te verbeteren, willen we graag dat u uw normale locatie invoert",
  "What do you use most?": "Wat gebruikt u het meest?",
  "To enable quicker and better search please chose you prefered resource type": "Voor een snellere en betere zoekopdracht kiest u uw gewenste resourcetype",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Klik op resource om te selecteren",
  "Selected Resources": "Geselecteerde resources",
  "Setting": "Instelling",
  "Search": "Zoeken",
  "Find Colleague": "Collega zoeken",
  "Quick button setting": "Snelknop-instelling",
  "Favorite": "Favoriet",
  "Most Used": "Meest gebruikt",
  "Colleagues": "Collega's",
  "Resources": "Resources",
  
  // AppConstants - tooltipText
  "Back": "Terug",
  "Floor Plan": "Plattegrond",
  "Expand": "Uitbreiden",
  "Selected resources": "Geselecteerde resources",
  "View details": "Details bekijken",
  "Remove from My Favorites": "Verwijderen uit mijn favorieten",
  "Add to My Favorites": "Toevoegen aan mijn favorieten",
  "Remove": "Verwijderen",
  "Favorite - Most Used": "Favoriet - Meest gebruikt",
  "Conflict": "Conflict",
  "Approved": "Goedgekeurd",
  "Recommendeded for you": "Aanbevolen voor u",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Alleen primaire organisator",
  "Only assistant organizer": "Alleen assistent-organisator",
  "Primary AND assistant organizer": "Primaire EN assistent-organisator",
  
  // FindColleague
  "Enter colleague name": "Voer colleganaam in",
  "Recent work items": "Recente werkitems",
  "No data available": "Geen gegevens beschikbaar",
  "Floorplan": "Plattegrond",
  "List nearby resources": "Lijst met resources in de buurt",
  "Find resource nearby": "Vind resource in de buurt",
  "No Resources available": "Geen resources beschikbaar",
  
  // Start page
  "Next": "Volgende",
  "Failed to update default locations": "Bijwerken van standaardlocaties mislukt",
  "Resource Type": "Resource type",
  
  // QuickSetting
  "Quick buttons updated successfully": "Snelknoppen succesvol bijgewerkt",
  "Quick buttons updated failed": "Bijwerken van snelknoppen mislukt",
  "Add more": "Meer toevoegen",
  "Apply": "Toepassen",
  "Delete": "Verwijderen",
  "Name": "Naam",
  "Enter name": "Voer naam in",
  "Tooltip": "Tooltip",
  "Enter tooltip": "Voer tooltip in",
  "Type": "Type",
  "Select type": "Selecteer type",
  "Locations": "Locaties",
  "Select colleagues": "Selecteer collega's",
  "Select resources": "Selecteer resources",
  
  // DefaultResourceSetting
  "Resource type changed": "Resource type gewijzigd",
  "Resource type change failed": "Wijzigen van resource type mislukt",
  "Default Resource Type": "Standaard resource type",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Succesvol toegepast",
  "Apply Failed": "Toepassen mislukt",
  "Assistant Organizer": "Assistent-organisator",
  "Enter a part of the name to search for": "Voer een deel van de naam in om te zoeken",
  "Mail Flow": "Mailstroom",
  "Select Mail Flow": "Selecteer mailstroom",
  
  // TileConfigurationSetting
  "Update settings successfully": "Instellingen succesvol bijgewerkt",
  "Update settings failed": "Bijwerken van instellingen mislukt",
  "Timeline": "Tijdlijn",
  
  // SelectCategoryForm
  "And": "En",
  "Or": "Of",
  
  // Other
  "Resource Calendar": "Resource kalender",
  
  // SettingLabels
  "Default Location": "Standaardlocatie",
  "Quick button": "Snelknop",
  "Category icons": "Categoriepictogrammen",
  "Recommendation screen": "Aanbevelingsscherm",
  "Capacity filter": "Capaciteitsfilter",
  "AI Assistant": "AI-assistent",
  "Tile configuration": "Tegelconfiguratie",
  "Help": "Help",
  "Default Categories": "Standaardcategorieën",
  
  // MeetingType
  "Your must select a Meeting label": "U moet een vergaderlabel selecteren",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Geselecteerde resource: 'AOD_Copanhagen' Conflicterende voorvallen",
  "Alternative Resource": "Alternatieve resource",
  "OK": "OK",
  "Cancel": "Annuleren",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Uw geselecteerde resource 'AOD_Copenhagen' is verwijderd",
  "You can't book this resource as your request exceeds the available capacity.": "U kunt deze resource niet boeken omdat uw verzoek de beschikbare capaciteit overschrijdt.",
  
  // ChangeTime
  "Time changed successfully": "Tijd succesvol gewijzigd",
  "Current Time": "Huidige tijd",
  "Suggested Times": "Voorgestelde tijden",
  "Change Time": "Tijd wijzigen",
  "people are free": "mensen zijn vrij",
};

